

import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const userTestimonials = [
  {
    avatar: (
      <Avatar
        alt="Ankit Gupta"
        src="/static/images/avatar/2.jpg"
        sx={{ bgcolor: "#C9F23C", color: "#dddddd" }}
      />
    ),
    name: "Ankit Gupta",
    occupation: "Mumbai, India",
    testimonial:
      "I love this website. I just got paid 20 rs and it was all so quick, just had to install an App",
  },
  {
    avatar: (
      <Avatar
        alt="Neeraj Khera"
        src="/static/images/avatar/2.jpg"
        sx={{ bgcolor: "#C9F23C", color: "#dddddd" }}
      />
    ),
    name: "Neeraj Khera",
    occupation: "Noida, India",
    testimonial: "Bahut hi sahi hai bhai, roj paisa milta hai paytm par",
  },
  {
    avatar: (
      <Avatar
        alt="Jeet Mody"
        src="/static/images/avatar/2.jpg"
        sx={{ bgcolor: "#C9F23C", color: "#dddddd" }}
      />
    ),
    name: "Jeet Mody",
    occupation: "Bangalore, India",
    testimonial:
      "Best app out there if you are a student, daily new tasks to install different Apps and easy money",
  },
];


const MobileTestimonial: React.FC<{
  testimonial: (typeof userTestimonials)[0];
  isActive: boolean;
}> = ({ testimonial, isActive }) => (
  <div
 
    style={{
      display: isActive ? "block" : "none",
      transition: "opacity 0.5s ease-in-out",
    }}
  >
    <Box
      sx={{
        background: "#1F3B2C", // Correctly wrapped gradient as a string
        borderRadius: "10px",
        p: 3,
        mx: 2,
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Box display="flex" alignItems="center" gap={2} mb={2}>
        {testimonial.avatar}
        <Typography
          variant="subtitle1"
          fontWeight="medium"
          fontSize="20px"
          color="#ffffff"
        
          
        >
          {testimonial.name}
        </Typography>
      </Box>
      <Typography
        variant="body2"
        color="#dddddd"
        fontWeight="regular"
        fontSize="14px"
        mb={2}
      >
        "{testimonial.testimonial}"
      </Typography>
      <Typography
        variant="body2"
        ml="200px"
        color="#dddddd"
        fontWeight="regular"
        fontSize="12px"
        sx={{ mt: "auto" }}
      >
        {testimonial.occupation}
      </Typography>
    </Box>
  </div>
);

export default function Testimonials() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeTestimonial, setActiveTestimonial] = React.useState(0);

  // Sliding feature for mobile devices
  React.useEffect(() => {
    if (isMobile) {
      const interval = setInterval(() => {
        setActiveTestimonial((prev) => (prev + 1) % userTestimonials.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [isMobile]);

  if (isMobile) {
    // Mobile-friendly design
    return (
      <Container
       id="testimonials"
        sx={{
          textAlign: "center",
          py: 6,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
        }}
      >
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontWeight: 800,
            textTransform: "uppercase",
            fontSize: "10.5px",
            letterSpacing: 1,
            color: "#ffffff",
          }}
        >
          Testimonials
        </Typography>
        <Typography
          variant="h4"
          component="div"
          sx={{
            fontWeight: 700,
            fontSize: "32px",
            color: "#C9F23C",
            mb: "8px",
            lineHeight: "1.1",
            fontFamily: '"Moan Slight", sans-serif'
          }}
        >
          Read All About Our Users Experiences
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "#dddddd",
            maxWidth: "90%",
            mb: "25px",
            fontWeight: 400,
            
            fontSize: "14px",
          }}
        >
          Discover how we have helped them earn extra money by installing Apps
          and completing tasks. Our simple and secure website is trusted by
          thousands of users across the country.
        </Typography>

        <Box sx={{ position: "relative", height: "200px" }}>
          {userTestimonials.map((testimonial, index) => (
            <MobileTestimonial
              key={index}
              testimonial={testimonial}
              isActive={activeTestimonial === index}
            />
          ))}
        </Box>

        {/* Dots for navigation */}
        <Box display="flex" justifyContent="center" gap={1}>
          {userTestimonials.map((_, index) => (
            <Box
              key={index}
              onClick={() => setActiveTestimonial(index)}
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor:
                  activeTestimonial === index ? "#C9F23C" : "#2A523D",
                cursor: "pointer",
              }}
            ></Box>
          ))}
        </Box>
      </Container>
    );
  }

  // Desktop and Tablet design (original)
  return (
    <Container
      id="testimonials"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Box
        sx={{
          width: { sm: "100%", md: "60%" },
          textAlign: { sm: "left", md: "center" },
        }}
      >
        <Typography component="h2" variant="h4" color="text.primary">
          Testimonials
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
          See what our customers love about our service. Discover how we have
          helped them earn extra money by installing Apps and completing tasks.
          Our simple and secure website is trusted by thousands of users across
          the country.
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {userTestimonials.map((testimonial, index) => (
          <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: "flex" }}>
            <Card
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                flexGrow: 1,
                p: 1,
                backgroundColor:
                  theme.palette.mode === "dark" ? "#495057" : "#e5e5e5",
              }}
            >
              <CardContent>
                <Typography variant="body2" color="text.secondary">
                  {testimonial.testimonial}
                </Typography>
              </CardContent>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  pr: 2,
                }}
              >
                <CardHeader
                  avatar={testimonial.avatar}
                  title={testimonial.name}
                  subheader={testimonial.occupation}
                />
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

